// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = theme => ({
  mainContainer: {
    width: '100%',
    zIndex: 2,
    display: 'flex',
    position: 'absolute',
    bottom: 0,
    height: 150,
    [theme.breakpoints.down(500)]: {
      height: 250,
    },
    [theme.breakpoints.down(330)]: {
      height: 350,
    },
  },
  relativeContainer: {
    width: '100%',
    height: '100%',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    zIndex: 5,
  },
  footerSection: {
    display: 'flex',
    flexDirection: 'column',
    margin: '10px 30px',
    [theme.breakpoints.down(800)]: {
      margin: 10,
    },
    [theme.breakpoints.down(330)]: {
      margin: 5,
    },
  },
  sectionLabel: {
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
  },
  link: {
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    marginTop: 5,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    '&:hover': {
      color: 'black',
      textDecoration: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  waveDesktop: {
    height: 150,
    width: '100%',
    top: -149,
    position: 'absolute',
  },
  waveMobile: {
    height: 300,
    width: '100%',
    bottom: 0,
    zIndex: 1,
    position: 'absolute',
    [theme.breakpoints.down(330)]: {
      height: 450,
    },
  },
  rectangleDesktop: {
    width: '100%',
    height: 150,
    zIndex: 1,
    position: 'absolute',
    bottom: 0,
  }
});

export default styles;
